import { Routes, mapToCanActivate } from '@angular/router';
import { CustomerLocationGuard } from '@next/core-lib/relationships';

import { TgaAccessGuard } from '../shared/guards/tga-access.guard';
import { unsavedChangesGuard } from '../shared/guards/unsaved-changes.guard';
import { NotificationHistoryComponent } from './components/notification-history/notification-history.component';
import { QuestionnaireLayoutComponent } from './components/questionnaire-layout/questionnaire-layout.component';
import { TgaCropfieldsSelectionComponent } from './components/tga-cropfields-selection/tga-cropfields-selection.component';
import { TgaComponent } from './components/tga.component';

export const tgaRoutes: Routes = [
  {
    path: 'tga/cropfields/:step/:mode/generic/:cropYear',
    component: QuestionnaireLayoutComponent,
    canActivate: mapToCanActivate([CustomerLocationGuard, TgaAccessGuard]),
    canDeactivate: [unsavedChangesGuard],
  },
  {
    path: 'tga/cropfields/:step/:mode/specific/:cropYear/:cropFieldId',
    component: QuestionnaireLayoutComponent,
    canActivate: mapToCanActivate([CustomerLocationGuard, TgaAccessGuard]),
    canDeactivate: [unsavedChangesGuard],
  },
  {
    path: 'tga/cropfields/:step/:mode/:cropYear/:cropFieldId',
    component: QuestionnaireLayoutComponent,
    canActivate: mapToCanActivate([CustomerLocationGuard, TgaAccessGuard]),
    canDeactivate: [unsavedChangesGuard],
  },
  {
    path: 'tga/cropfields',
    component: TgaCropfieldsSelectionComponent,
    canActivate: mapToCanActivate([CustomerLocationGuard, TgaAccessGuard]),
  },
  {
    path: 'tga/notifications/history',
    component: NotificationHistoryComponent,
    canActivate: mapToCanActivate([CustomerLocationGuard, TgaAccessGuard]),
  },
  {
    path: 'tga',
    component: TgaComponent,
    canActivate: mapToCanActivate([CustomerLocationGuard, TgaAccessGuard]),
  },
];
